var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.122,
    height: 40,
    viewBox: "0 0 41.122 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_132104",
    "data-name": "Group 132104",
    transform: "translate(-745.935 -1670.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6185",
    "data-name": "Rectangle 6185",
    width: 40,
    height: 40,
    transform: "translate(746.494 1670.629)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "binoculars",
    transform: "translate(746.496 1676.349)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95885",
    "data-name": "Path 95885",
    d: "M12.712,21.284a1.428,1.428,0,1,1-2.856,0,1.429,1.429,0,0,0-1.428-1.428,1.428,1.428,0,1,1,0-2.856A4.289,4.289,0,0,1,12.712,21.284Z",
    transform: "translate(0.147 -1.292)",
    fill: "#09143a",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95886",
    "data-name": "Path 95886",
    d: "M28.712,21.284a1.428,1.428,0,0,1-2.856,0,1.429,1.429,0,0,0-1.428-1.428,1.428,1.428,0,0,1,0-2.856A4.289,4.289,0,0,1,28.712,21.284Z",
    transform: "translate(6.995 -1.292)",
    fill: "#09143a",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_991_",
    d: "M41.254,22.538c0-.007,0-.016,0-.023l-5.414-13a5.713,5.713,0,0,0-10.986,2.2v1.974a8.111,8.111,0,0,0-5.712,0V11.712a5.712,5.712,0,0,0-10.984-2.2l-5.414,13c0,.007,0,.016,0,.023a8.565,8.565,0,1,0,16.4,3.453v-3.47a5.485,5.485,0,0,1,5.712,0v3.47a8.566,8.566,0,1,0,16.4-3.454ZM27.706,11.712a2.857,2.857,0,0,1,5.494-1.1l3.039,7.3a8.493,8.493,0,0,0-8.532,1.714Zm-16.918-1.1a2.857,2.857,0,0,1,5.494,1.1v7.911A8.49,8.49,0,0,0,7.75,17.91ZM10.57,31.7a5.712,5.712,0,1,1,5.712-5.712A5.718,5.718,0,0,1,10.57,31.7ZM21.994,18.859a8.254,8.254,0,0,0-2.856.52V16.8a5.479,5.479,0,0,1,5.712,0v2.583A8.254,8.254,0,0,0,21.994,18.859ZM33.418,31.7a5.712,5.712,0,1,1,5.712-5.712A5.718,5.718,0,0,1,33.418,31.7Z",
    transform: "translate(-1.995 -6)",
    fill: "#09143a",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.b9a16587b1123806f5ade03aa23b560c.svg";
export { ForwardRef as ReactComponent };